import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllChristmas,
  getSingleChristmas,
  createChristmas,
  updateChristmas,
  deleteChristmas,
} from "@/api/new-api/staff-management/menu-manage/special-menu/christmas-lunches";

// Thunks

export const fetchAllChristmas = createAsyncThunk(
  "christmas/fetchAll",
  async (restaurant_id, { rejectWithValue }) => {
    const res = await getAllChristmas(restaurant_id);
    if (res.status === "success") return res.data.christmas_lunches;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleChristmas = createAsyncThunk(
  "christmas/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleChristmas(id);
    if (res.status === "success") return res.data.christmas_lunch;
    return rejectWithValue(res.message);
  }
);

export const createNewChristmas = createAsyncThunk(
  "christmas/create",
  async (data, { rejectWithValue }) => {
    const res = await createChristmas(data);
    if (res.status === "success") return res.data.christmas_lunch;
    return rejectWithValue(res.message);
  }
);

export const updateExistingChristmas = createAsyncThunk(
  "christmas/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateChristmas(id, data);
    if (res.status === "success") return res.data.christmas_lunch;
    return rejectWithValue(res.message);
  }
);

export const deleteChristmasById = createAsyncThunk(
  "christmas/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteChristmas(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State
const initialState = {
  christmasLunches: [],
  singleChristmasLunch: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice
const christmasSlice = createSlice({
  name: "christmas",
  initialState,
  reducers: {
    clearChristmasMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchAllChristmas.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllChristmas.fulfilled, (state, action) => {
        state.getLoading = false;
        state.christmasLunches = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllChristmas.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleChristmas.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleChristmas.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleChristmasLunch = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleChristmas.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewChristmas.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewChristmas.fulfilled, (state, action) => {
        state.createLoading = false;
        state.christmasLunches.push(action.payload);
        state.success = "Christmas lunch created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewChristmas.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingChristmas.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingChristmas.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.christmasLunches = state.christmasLunches.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
        state.success = "Christmas lunch updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingChristmas.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteChristmasById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteChristmasById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.christmasLunches = state.christmasLunches.filter(
          (item) => item.id !== action.payload
        );
        state.success = "Christmas lunch deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteChristmasById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearChristmasMessages } = christmasSlice.actions;
export default christmasSlice.reducer;
